import i18next  from 'i18next';

import es from './es';
import pt from './pt';
import en from './en';

i18next.addResourceBundle('es', 'footer', es);
i18next.addResourceBundle('en', 'footer', en);
i18next.addResourceBundle('pt', 'footer', pt);